import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Administrator } from '../../core/models';
import {AuthenticationService} from "../../core/services";
import {TranslationService} from "../../core/services/translation.service";
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  administrator: Administrator;
  isDarkTheme = true;

  constructor(private authenticationService: AuthenticationService,
              private translationService: TranslationService,
              private route: ActivatedRoute) {
    this.route.data.subscribe((data) => {
      this.administrator = data['administrator'];
    });
  }

  ngOnInit() {
    this.translationService.loadTranslations('admin');
  }

  doSignOut() {
    this.authenticationService.signOut().subscribe(() => {
      location.reload();
    })
  }

  goToSidekiq(): void {
    this.goTo(environment.sidekiqUrl);
  }

  goToSupport(): void {
    this.goTo('https://support.grant.nu/');
  }

  private goTo(url: string): void {
    window.open(url, "_blank");
  }

  checkThemeType(currentTheme: string): void {
    this.isDarkTheme = (currentTheme === 'dark-theme' || currentTheme === 'cyan-theme');
  }
}
